import { StowageRulesMapsBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulesMapsBM';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { ProductCategory } from 'src/types/ViewModel/Stowage/Product/ProductCategory';
import { commodityBookStowageRules } from './stowageRulesManager/stowageRulesUtils';
import { ProductAllowanceEnum } from 'src/types/BusinessModel/Stowage/Product/ProductAllowanceEnum';

export function mapProducts(productList: Product[], productCategoryList: ProductCategory[], stowageRulesMapBM: StowageRulesMapsBM): void {
    // Build Maps for O(1) lookups instead of nested .filter() + .some()
    const rulesByCategory = new Map<number, Set<number>>();
    for (const srpcm of stowageRulesMapBM.stowageRuleProductCategoryMap) {
        let set = rulesByCategory.get(srpcm.productCategoryId);
        if (!set) {
            set = new Set();
            rulesByCategory.set(srpcm.productCategoryId, set);
        }
        set.add(srpcm.stowageRuleId);
    }

    const rulesByProduct = new Map<number, Set<number>>();
    for (const srpm of stowageRulesMapBM.stowageRuleProductMap) {
        let set = rulesByProduct.get(srpm.productId);
        if (!set) {
            set = new Set();
            rulesByProduct.set(srpm.productId, set);
        }
        set.add(srpm.stowageRuleId);
    }

    const categoryById = new Map<number, ProductCategory>();
    productCategoryList.forEach((pc) => {
        categoryById.set(pc.id, pc);
        const ruleIds = rulesByCategory.get(pc.id);
        pc.stowageRules = ruleIds ? commodityBookStowageRules.filter((sr) => ruleIds.has(sr.id)) : [];
    });

    productList.forEach((p) => {
        p.category = categoryById.get(p.categoryId);
        const ruleIds = rulesByProduct.get(p.id);
        p.stowageRules = ruleIds ? commodityBookStowageRules.filter((sr) => ruleIds.has(sr.id)) : [];
    });
}

export function getFosfaListStatus(product: Product): string {
    switch (product.fosfaAllowance) {
        case ProductAllowanceEnum.Acceptable:
            return 'On FOSFA list of acceptable previous cargoes';
        case ProductAllowanceEnum.Banned:
            return 'On FOSFA list of banned immediate previous cargoes';
        case ProductAllowanceEnum.NotListed:
            return 'Not on FOSFA lists';
        default:
            return 'FOSFA status not specified';
    }
}
